import {shallowEqual} from 'react-redux';
import {useAppSelector} from '@/hooks';

export function useDrilledGroupItem(pageId?: string): {itemId: string; groupId: string} | null {
  return useAppSelector((state) => {
    const pageHashedId = pageId ?? state.posterEditor.currentPageId;
    if (!pageHashedId) {
      return null;
    }
    const ids = state.posterEditor.activeItemIds[pageHashedId];
    if (!ids || ids.length !== 1) {
      return null;
    }
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[pageHashedId]?.items.itemsHashMap[ids[0]];
    if (!item?.groupId) {
      return null;
    }
    return {itemId: ids[0], groupId: item.groupId};
  }, shallowEqual);
}
